// extracted by mini-css-extract-plugin
export var dark = "links-module--dark--5e817";
export var link = "links-module--link--1a81a";
export var linkItem = "links-module--linkItem--8443c";
export var root = "links-module--root--be2bd";